import { render, staticRenderFns } from "./CategoryBlock.vue?vue&type=template&id=9534337a&scoped=true"
import script from "./CategoryBlock.vue?vue&type=script&lang=js"
export * from "./CategoryBlock.vue?vue&type=script&lang=js"
import style0 from "./CategoryBlock.vue?vue&type=style&index=0&id=9534337a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9534337a",
  null
  
)

export default component.exports